import { render, staticRenderFns } from "./search-type-selector.vue?vue&type=template&id=5aedf8ec"
import script from "./search-type-selector.vue?vue&type=script&lang=js"
export * from "./search-type-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports